import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class FlowAndPressureSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.FlowAndPressureSensor,
    });
  }
}
